import { Box } from '@material-ui/core';

import { getBankDetailsByAccountNumber } from '@/components/modules/BorrowerAccountDetails/utils/getBankDetailsByAccountNumber';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface CreditCardIncomeProps extends FormGridOptions {
  holderName: string;
  accountNumber: string;
}

export const CreditCardIncome = ({ holderName, fieldVariant, fullWidth, accountNumber }: CreditCardIncomeProps) => {
  const { isMobile } = useScreen();
  const bankDetails = getBankDetailsByAccountNumber({ accountNumber });
  return (
    <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
      <TextFormField
        label={isMobile ? 'IBAN' : 'ACCOUNT_NUMBER'}
        value={accountNumber}
        name={'accountNumber'}
        copyToClipboard
      />
      <TextFormField label={'HOLDER_NAME'} value={holderName} name={'accountNumber'} />
      {bankDetails && (
        <Box display={'flex'} flexDirection={'column'} py={'6px'} width={'100%'}>
          <Box pb={'6px'} flexGrow={1} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Font className={'overflow-text-ellipsis'} variant="subtitle2" color="textSecondary">
              <Text tId={'BANK_NAME'} />
            </Font>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'} pb={'2px'}>
              <Font variant="h5" color="textPrimary" style={{ textAlign: 'right', paddingLeft: '8px' }}>
                {bankDetails.NAME}
              </Font>
              {bankDetails.LENDER_NAME && (
                <LenderIcon lenderName={bankDetails.LENDER_NAME} style={{ marginLeft: 6, paddingBottom: '5px' }} />
              )}
            </Box>
          </Box>
          <CustomDivider margin={0} />
        </Box>
      )}
    </FormGridContainer>
  );
};
